import React, { useEffect, useState } from 'react'
import { plazaServices } from './tollPlaza/plazaReportService'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import moment from 'moment';
export const sortObjArrbyKey = (arr, key, value) => {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][key] !== value) {
            for (let j = i + 1; j < arr.length; j++) {
                if (arr[j][key] === value) {
                    let temp = arr[i];
                    arr[i] = arr[j]
                    arr[j] = temp;
                }

            }
        }
    }
    return arr;
}

const DesinerStatusPage = () => {
    const serviceId = localStorage.getItem("serviceId")
    const [orgData, setOrgData] = useState()
    const [dupData, setDupData] = useState()
    const [selectedStatus,setSelectedStatus] = useState()
    useEffect(() => {
        Promise.all([plazaServices.general(serviceId, { projection: { blockAccess: 1, expired: 1, Balance: 1, expiry_date: 1, plan_MonthCount: 1, planBasePrice: 1, planUser: 1, planName: 1, designerID: 1 } }, "nq-designer-plan")]).then((res) => {
            if (res && res.length){
                setDupData(sortObjArrbyKey(res[0]))
                setOrgData(sortObjArrbyKey(res[0]))
            }
        })
    }, [])
    const handleStatusChange  = (status)=>{
        let temp = orgData && orgData.length && orgData.filter((item)=>{
            return status==="All"?true:item[status]
        })
        setDupData(temp)

    }
    const userpermissions = JSON.parse(localStorage.getItem("permissions"))
    const isAdmin = (userpermissions.includes("super.ADMIN"))
    
    return isAdmin?(
        <div className='col-12 '>
            <Dropdown
                    id="tollDropdown"
                    value={selectedStatus}
                    optionLabel='name'
                    options={[{name:"All",value:"All"},{name:"Access Blocked",value:"blockAccess"},{name:"Plan Expired",value:"expired"}]}
                    onChange={(e) => {
                        setSelectedStatus(e.target.value)
                        handleStatusChange(e.target.value)

                    }}
                    placeholder="Select a Status"
                    className="general-bar-chart-filter flex align-items-center lg:col-3 col-12"
                     style={{
                            borderRadius: "20px",
                            boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                            border: "1px solid #ddd",
                            background: "transparent",
                            height: "3rem",
                            fontSize: "14px",
                            fontFamily: "Inter"
                        }}
                />
            <DataTable value={dupData} paginator={true} rows={10} responsiveLayout="scroll"
             className="w-full card-table"
                        rowClassName={() => 'card-row'}
            >
                {
                    [{ head: "Designer ID", field: "designerID" }, { head: "Plan Name", field: "planName" }, { head: "Plan User", field: "planUser" }, { head: "Balance", field: "Balance" }].map((item) => {
                        return <Column  headerClassName="dataTableHeader" className="bg-white font-medium  bg-gray-200" header={item.head} field={item.field}></Column>
                    })
                }
                <Column  headerClassName="dataTableHeader" className="bg-white font-medium  bg-gray-200" header="Expiry Date"  body={(row)=>{return moment(row["expiry_date"], 'YYYY-MM-DD,h:mm').format('Do,MMM YY')}}></Column>
                <Column  headerClassName="dataTableHeader" className="bg-white font-medium  bg-gray-200" header={"Access Status"} body={(row) => { return row.blockAccess ? "Access Blocked" : "Allowed" }}></Column>
                <Column   headerClassName="dataTableHeader" className="bg-white font-medium  bg-gray-200" header={"Plan Status"} body={(row) => { return row.expired ? "Expired" : "Not Expired" }}></Column>
            </DataTable>
        </div>
    ):<div className="col-12 " style={{ color: "#01579B" }}>
    <div className="card flex flex-column align-items-center justify-content-center dijon-ivory" style={{ height: "60vh"}}>
        <span className="fa-solid fa-circle-info" style={{ fontSize: "3rem" }}></span>
        <h3 className='font-larken'>You are not authorized to access this page</h3>
    </div>
</div>
}

export default DesinerStatusPage